import { useEffect, useRef, useState, useMemo, useCallback } from 'react'
import ReactPlayer from 'react-player'
import { useSelector } from 'react-redux'
import Slider from 'react-slick'
import playImg from '../../../../Assets/new-assets/play.svg'
import noVideoImg from '../../../../Assets/new-assets/no-video.svg'

const VideoBox = ({ url, isPlaying, isLoading, videoError, setIsPlaying, setIsLoading, setVideoError }) => {
  if (videoError) {
    return (
      <div className="is-not-video inter">
        <img src={noVideoImg} alt="Video error" />
        Failed to load video
      </div>
    )
  }

  if (url) {
    return (
      <div className="video-player-wrapper col-md-12">
        <ReactPlayer
          key={url}
          url={url}
          controls={true}
          height={'100%'}
          width={'100%'}
          className="summary-video summary-video-intro"
          playing={isPlaying}
          onReady={() => setIsLoading(false)}
          onBuffer={() => setIsLoading(true)}
          onBufferEnd={() => setIsLoading(false)}
          onPlay={() => setIsPlaying(true)}
          onPause={() => setIsPlaying(false)}
          onEnded={() => setIsPlaying(false)}
          onError={(e) => {
            setVideoError(e)
            setIsLoading(false)
          }}
          config={{
            file: {
              attributes: {
                preload: 'metadata',
              },
            },
          }}
        />
      </div>
    )
  }
  return (
    <div className="is-not-video inter">
      <img src={noVideoImg} alt="No video" />
      No Video to display
    </div>
  )
}

const ThumbnailPreview = ({ url, thumbnailUrl, isActive }) => {
  if (url) {
    return (
      <div className={`videothumbnail ${isActive ? 'active' : ''}`}>
        <img src={playImg} className="play-icon" alt="Play" />
        <img src={thumbnailUrl || 'https://storage.googleapis.com/kidex-thumbnails-in/feeds/1c426beb-729a-45dd-9c5b-2bfd9ff4cefe1722867327022.jpg'} className="h-100" alt="Video thumbnail" />
      </div>
    )
  }
  return (
    <div className="videothumbnail">
      <img src={noVideoImg} alt="No video" />
    </div>
  )
}

const InnerVideoSection = ({ urlData, snapshotData, skillData }) => {
  const [currentVideoUrl, setCurrentVideoUrl] = useState('')
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0)
  const [isPlaying, setIsPlaying] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [videoError, setVideoError] = useState(null)

  const videoUrls = urlData || []
  const thumbnailUrls = snapshotData || []
  const thumbnailTitles = skillData?.map((skill) => skill?.title || '') || []

  const thumbSettings = useMemo(
    () => ({
      dots: false,
      infinite: videoUrls.length > 4,
      slidesToShow: videoUrls.length >= 4 ? 4 : videoUrls.length,
      slidesToScroll: 1,
      swipeToSlide: true,
      arrows: true,
      centerMode: videoUrls.length > 4,
      centerPadding: '20px',
      focusOnSelect: true,
      verticalSwiping: false,
      responsive: [
        {
          breakpoint: 580,
          settings: {
            slidesToShow: videoUrls.length >= 3 ? 3 : videoUrls.length,
            slidesToScroll: 1,
            swipeToSlide: true,
            arrows: false,
            centerMode: videoUrls.length > 3,
            centerPadding: '20px',
            focusOnSelect: true,
            infinite: videoUrls.length > 3,
          },
        },
      ],
    }),
    [videoUrls.length],
  )

  useEffect(() => {
    if (videoUrls.length > 0 && videoUrls[0]) {
      setCurrentVideoUrl(videoUrls[0])
      setCurrentVideoIndex(0)
    }
  }, [videoUrls.length])

  const handleThumbnailClick = useCallback(
    (index) => {
      setIsPlaying(false)
      setVideoError(null)
      setCurrentVideoUrl(videoUrls[index])
      setCurrentVideoIndex(index)
      setIsLoading(true)
      setTimeout(() => {
        setIsPlaying(true)
      }, 100)
    },
    [videoUrls],
  )

  if (videoUrls.length === 0) {
    return null
  }

  return (
    <div className="mb-5 pb-3">
      <div className="digital-portfolio-videos col-md-6">
        <VideoBox url={currentVideoUrl} isPlaying={isPlaying} isLoading={isLoading} videoError={videoError} setIsPlaying={setIsPlaying} setIsLoading={setIsLoading} setVideoError={setVideoError} />
      </div>
      <Slider {...thumbSettings} className="thumbnail-slider mt-3">
        {videoUrls.map((url, index) => (
          <div key={`video-${index}-${url}`} onClick={() => handleThumbnailClick(index)} style={{ cursor: 'pointer' }}>
            <ThumbnailPreview url={url} thumbnailUrl={thumbnailUrls[index]} isActive={currentVideoIndex === index} />
            <h3 className="thumbnail-title">{thumbnailTitles[index]}</h3>
          </div>
        ))}
      </Slider>
    </div>
  )
}

const VideoSection = ({ kidId, data }) => {
  const contentDivRef = useRef(null)
  const secondStepData = useSelector((state) => state.ProfileSteps.SecondStepData)

  const videoData = secondStepData?.activity_details?.youtube || []

  const snapshotData = useMemo(() => videoData.map((item) => `https://img.youtube.com/vi/${item?.url}/hqdefault.jpg`), [videoData])

  const urlData = useMemo(() => videoData.map((item) => `https://www.youtube.com/watch?v=${item?.url}`), [videoData])

  if (!videoData.length) {
    return (
      <div ref={contentDivRef}>
        <div className="text-center fs-5 fw-500">No videos to show...</div>
      </div>
    )
  }

  return (
    <div ref={contentDivRef}>
      <InnerVideoSection urlData={urlData} snapshotData={snapshotData} skillData={videoData} />
    </div>
  )
}

export default VideoSection
